import { ResourceTypeKeys } from './types';

export function setClarityFirstVideo(showClarityFirstVideo: boolean) {
  return {
    type: ResourceTypeKeys.SET_CLARITYFIRST_VIDEO,
    showClarityFirstVideo,
  };
}
